'use client'

import { LuneTheme, useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import Forto from '@public/images/logos/forto.png'
import Greencarrier from '@public/images/logos/greencarrier.png'
import Imperative from '@public/images/logos/imperative.png'
import Jas from '@public/images/logos/jas.svg'
import Logixboard from '@public/images/logos/logixboard.png'
import Lvo from '@public/images/logos/lvo.png'
import Magaya from '@public/images/logos/magaya.png'
import VAlexander from '@public/images/logos/valexander.png'

import LogosGrid from '@/components/LogosGrid'

const logos1 = [
    {
        name: 'Jas',
        img: Jas,
        width: 83.72,
        height: 32,
    },
    {
        name: 'Forto',
        img: Forto,
        width: 77.68,
        height: 19,
    },
    {
        name: 'Logixboard',
        img: Logixboard,
        width: 140.52,
        height: 16,
    },
    {
        name: 'Imperative',
        img: Imperative,
        width: 113.5,
        height: 24,
    },
]
const logos2 = [
    {
        name: 'LVO',
        img: Lvo,
        width: 64,
        height: 49,
    },
    {
        name: 'V. Alexander',
        img: VAlexander,
        width: 127.5,
        height: 38,
    },
    {
        name: 'Greencarrier',
        img: Greencarrier,
        width: 144,
        height: 20,
    },
    {
        name: 'Magaya',
        img: Magaya,
        width: 125.5,
        height: 25,
    },
]

const EmbedClimateContributionsLogos = ({ caption }: { caption?: string }) => {
    const { palette } = LuneTheme
    const { smScreen } = useDevice()
    return (
        <>
            <Box
                sx={{
                    position: 'relative',
                    '&:after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: '-50%',
                        right: '-50%',
                        height: '1px',
                        backgroundColor: `${palette.Grey300}`,
                        mx: {
                            lg: 37,
                            xl: 37,
                        },
                    },
                }}
            >
                {caption ? (
                    <Text
                        variant={'body2'}
                        sx={{ textAlign: 'center', pt: 6, color: palette.Grey900 }}
                    >
                        {caption}
                    </Text>
                ) : null}
                {smScreen ? (
                    <LogosGrid sx={{ pt: 6, pb: 6 }} logos={[...logos1, ...logos2]} />
                ) : (
                    <>
                        <LogosGrid sx={{ height: '120px', lineHeight: '120px' }} logos={logos1} />
                        <LogosGrid
                            sx={{ height: '120px', lineHeight: '120px', marginTop: '-48px' }}
                            logos={logos2}
                        />
                    </>
                )}
            </Box>
        </>
    )
}

export default EmbedClimateContributionsLogos
